import { Stack, Typography, Chip, Select, MenuItem, Button } from "@mui/material";
import * as React from "react";
import { Link as RouterLink } from "react-router";
import { routePaths } from "../../../../Router/router";

import MissingAssetSubbar from "../../../../Components/Subbars/MissingAssetSubbar";
import FullTaskTopbar from "../../../../Components/Topbars/FullTaskTopbar";
import FullTaskLayout from "../../../../Layouts/FullTask";

import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import SubtitlesOutlinedIcon from "@mui/icons-material/SubtitlesOutlined";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useTranslation } from "react-i18next";

function IngestMissingAssetRequest() {
  const { t } = useTranslation();
  return (
    <FullTaskLayout
      withContainer
      subbarHeight={80}
      TopBar={
        <FullTaskTopbar
          title={t("page:fullTaskTopbar.title.requestAssets")}
          leftContent={
            <Chip
              color="warning"
              label={t("chip:label.missingAssetsRemaining", { count: 12 })}
              icon={<ErrorOutlineIcon />}
              variant="outlined"
            />
          }
          rightContent={
            <>
              <Stack alignItems="flex-end" textAlign="right" mr={1}>
                <Select
                  displayEmpty
                  IconComponent={ExpandMoreRoundedIcon}
                  startAdornment={<SubtitlesOutlinedIcon />}
                  MenuProps={{ PaperProps: { sx: { maxHeight: 600 } } }}
                  value=""
                >
                  <MenuItem value="">{`${t("common:totalRecallLowerCase")} - ${t("common:bonus")} - ${t(
                    "common:subtitles"
                  )}`}</MenuItem>
                  <MenuItem value="title">{t("common:optionNumber", { number: 2 })}</MenuItem>
                  <MenuItem value="quality">{t("common:optionNumber", { number: 3 })}</MenuItem>
                </Select>
              </Stack>
              <Button
                to={routePaths.ingest.path}
                component={RouterLink}
                color="primary"
                variant="contained"
                endIcon={<ArrowForwardIcon />}
              >
                {t("button:createRequest")}
              </Button>
            </>
          }
        />
      }
      Subbar={<MissingAssetSubbar />}
      sxContainer={{ maxWidth: { lg: 1700 }, pt: 4, pb: 4, height: "100%" }}
      sxAppbar={{ bgcolor: "background.paper" }}
    >
      <Stack alignItems="center" justifyContent="center" height="100%">
        <Typography variant="h5" component="h2" fontWeight={600}>
          {t("page:body.selectPackToYourRequest")}
        </Typography>
        <Typography color="text.tier" mt={1}>
          {t("page:body.selectPackInTheUpperRightDropdown")}
        </Typography>
      </Stack>
    </FullTaskLayout>
  );
}

export default IngestMissingAssetRequest;
